@if (!embedded() && backgrounds()) {
    <app-playground
        [backgrounds]="backgrounds()"
        title="{{ 'machinesearch' | translate }}"
    >
    </app-playground>
}
@if (machineinfos) {
    <div class="container">
        @if (!router.url.includes("/machine-details/")) {
            <app-breadcrumbs class="col-lg d-md-inline d-none">
            </app-breadcrumbs>
        }
        @if (router.url.includes("/machine/")) {
            <div class="row pt-2">
                @if (machineData?.phkey) {
                    <div
                        class="justify d-none d-md-block"
                        style="margin-right: -70px; flex: 0; min-width: 200px"
                    >
                        <img
                            style="max-width: 60%; max-height: 100px"
                            src="//www.poettinger.at/img/icons_svg/300/{{
                                machineData?.phkey
                            }}.svg"
                            alt="{{ machineData?.phkey }}"
                        />
                    </div>
                }
                <div class="d-block flex-1" style="margin: auto 0">
                    <p class="machineHeader">
                        {{ machineinfos.maktx }} <br />
                        <span id="sernr-hover-trigger">{{
                            machineinfos.matnr
                        }}</span>
                    </p>
                </div>
                @if (machineinfos.serNr) {
                    <ion-popover
                        id="sernr-popover"
                        trigger="sernr-hover-trigger"
                        triggerAction="hover"
                        (mousemove)="onMouseMove($event)"
                    >
                        <ng-template>
                            <ion-content class="ion-padding">{{
                                machineinfos.serNr
                            }}</ion-content>
                        </ng-template>
                    </ion-popover>
                }
                <div class="d-block d-md-none flex-1">
                    @if (fetching) {
                        <ion-spinner></ion-spinner>
                    }
                </div>
                <div class="align-center d-none d-md-block m-auto flex-1">
                    @if (fetching) {
                        <ion-spinner></ion-spinner>
                    }
                    <div
                        style="
                            display: flex;
                            flex-direction: column;
                            align-items: end;
                            justify-content: center;
                        "
                    >
                        @if (machineinfos?.detectedType === "zvar" && showConfiguratorButton(machineData?.rootKey)) {
                            <button
                                class="button btn-poettinger configurator-button"
                                (click)="openConfigurator($event)"
                            >
                                {{ "configure" | translate }}
                            </button>
                        }
                        @if (!userOwnsMachine() && viewMode() !== "kiosk") {
                            <div
                                class="add-to-park p-0"
                                (click)="onAddToMachinePark(machineinfos)"
                                (keypress)="onAddToMachinePark(machineinfos)"
                                [ngClass]="{ 'opacity-2': !isAuthed() }"
                            >
                                <p>
                                    {{ "AddToPark" | translate }}
                                    <em
                                        class="far fa-star pl-3"
                                        style="font-size: 1.3rem"
                                    ></em>
                                </p>
                            </div>
                        }
                    </div>
                </div>

                <div class="pt-3 d-md-none align-items-end d-flex flex-column">
                    @if (machineinfos?.detectedType === "zvar") {
                        <button
                            class="button btn-poettinger configurator-button"
                            (click)="openConfigurator($event)"
                        >
                            {{ "configure" | translate }}
                        </button>
                    }
                    @if (!userOwnsMachine() && viewMode() !== "kiosk") {
                        <div
                            class="add-to-park p-0"
                            (click)="onAddToMachinePark(machineinfos)"
                            (keydown.enter)="onAddToMachinePark(machineinfos)"
                            [ngClass]="{ 'opacity-2': !isAuthed() }"
                        >
                            <p>
                                <em
                                    class="far fa-star"
                                    style="font-size: 1.3rem"
                                ></em>
                                {{ "AddToPark" | translate }}
                            </p>
                        </div>
                    }
                </div>
            </div>
        }

        <router-outlet></router-outlet>
        @if (
            machineinfos?.detectedType === "serial" && !machineinfos?.consigned
        ) {
            <ion-card class="pending-consignment">
                <ion-card-content>
                    <span>{{ "ConsignedFalse" | translate }}</span>
                    <ion-icon
                        id="pending-consignment-popover-trigger"
                        name="information-circle-outline"
                        slot="end"
                    ></ion-icon>
                    <ion-popover
                        trigger="pending-consignment-popover-trigger"
                        class="pending-consignment-popover"
                        triggerAction="hover"
                        (mousemove)="onMouseMove($event)"
                    >
                        <ng-template>
                            <ion-content class="ion-padding">
                                <p>
                                    {{
                                        "ConsignedFalseDescription" | translate
                                    }}
                                </p>
                            </ion-content>
                        </ng-template>
                    </ion-popover>
                </ion-card-content>
            </ion-card>
        }
        @if (route.children?.length === 0) {
            <div class="row pt-4">
                <div class="col">
                    <ion-accordion-group
                        #outerAccordionGroup
                        class="outer-accordion-group"
                        (ionChange)="scrollIntoView($event.detail.value)"
                    >
                        @if (
                            machineinfos.highlights?.length > 2 ||
                            machineinfos.fitments.options?.length > 0 ||
                            machineinfos.fitments.fitted?.length > 0 ||
                            machineinfos.technicalData?.length > 0
                        ) {
                            <ion-accordion>
                                <ion-item slot="header" color="medium">
                                    <ion-label>{{
                                        "equipmentAndTechnicalData" | translate
                                    }}</ion-label>
                                </ion-item>
                                <ion-accordion-group
                                    slot="content"
                                    (ionChange)="accordionGroupChange($event)"
                                >
                                    @if (machineinfos.highlights?.length > 2) {
                                        <ion-accordion>
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "highlights" | translate
                                                }}</ion-label>
                                            </ion-item>
                                            <app-highlight-cards
                                                slot="content"
                                                [chassisnr]="
                                                    machineinfos.chassisnr
                                                "
                                                [highlights]="
                                                    machineinfos.highlights
                                                "
                                            ></app-highlight-cards>
                                        </ion-accordion>
                                    }
                                    @if (
                                        machineinfos.fitments.options?.length >
                                            0 ||
                                        machineinfos.fitments.fitted?.length > 0
                                    ) {
                                        <ion-accordion value="fitments">
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "fitments" | translate
                                                }}</ion-label>
                                            </ion-item>
                                            <app-fitments
                                                slot="content"
                                                [fitted]="
                                                    machineinfos.fitments.fitted
                                                "
                                                [optional]="
                                                    machineinfos.fitments
                                                        .options
                                                "
                                            ></app-fitments>
                                        </ion-accordion>
                                    }
                                    @if (
                                        machineinfos.technicalData?.length > 0
                                    ) {
                                        <ion-accordion>
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "technicaldata" | translate
                                                }}</ion-label>
                                            </ion-item>
                                            <app-highlights-and-data
                                                slot="content"
                                                style="
                                                    display: block;
                                                    margin-left: 1rem;
                                                "
                                                [htmlstring]="
                                                    machineinfos.technicalData
                                                "
                                                mode="technicaldata"
                                            >
                                            </app-highlights-and-data>
                                        </ion-accordion>
                                    }
                                </ion-accordion-group>
                            </ion-accordion>
                        }
                        @if (
                            availableUpgrades?.hasValue() &&
                            availableUpgrades.value().length > 0
                        ) {
                            <ion-accordion>
                                <ion-item slot="header" color="medium">
                                    <ion-label>{{
                                        "upgrades" | translate
                                    }}</ion-label>
                                </ion-item>
                                <ion-list slot="content">
                                    @for (
                                        upgrade of availableUpgrades.value();
                                        track upgrade.id
                                    ) {
                                        <ion-item lines="full">
                                            <ion-label>{{
                                                upgrade.name
                                            }}</ion-label>
                                        </ion-item>
                                    }
                                </ion-list>
                            </ion-accordion>
                        }
                        @if (
                            areDocumentsAvailable(machineinfos.manuals) ||
                            areDocumentsAvailable(
                                machineinfos.retrofitManuals
                            ) ||
                            areDocumentsAvailable(
                                machineinfos.assemblingInstructions
                            ) ||
                            areDocumentsAvailable(
                                machineinfos.repairingInstructions
                            ) ||
                            areDocumentsAvailable(
                                machineinfos.sparepartsLists
                            ) ||
                            areDocumentsAvailable(
                                machineinfos.lubricationPlans
                            ) ||
                            (areDocumentsAvailable(
                                machineinfos.mechatronicPlans
                            ) &&
                                viewMode() === "poetdoc") ||
                            declarationOfConformityHeadResource.hasValue()
                        ) {
                            <ion-accordion value="machinedocumentation">
                                <ion-item slot="header" color="medium">
                                    <ion-label>{{
                                        "machineDocumentation" | translate
                                    }}</ion-label>
                                </ion-item>
                                <ion-accordion-group
                                    #machineDocumentationAccordionGroup
                                    slot="content"
                                    (ionChange)="
                                        scrollIntoView($event.detail.value)
                                    "
                                >
                                    @if (
                                        areDocumentsAvailable(
                                            machineinfos.manuals
                                        )
                                    ) {
                                        <ion-accordion value="operationmanual">
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "operationmanual"
                                                        | translate
                                                }}</ion-label>
                                            </ion-item>

                                            @if (
                                                isAuthed() ||
                                                ["poetdoc", "ba"].includes(
                                                    viewMode()
                                                )
                                            ) {
                                                <app-zmedias
                                                    slot="content"
                                                    [mode]="'operationmanual'"
                                                ></app-zmedias>
                                            } @else {
                                                <app-auth-prompt
                                                    slot="content"
                                                    [showTitle]="true"
                                                ></app-auth-prompt>
                                            }
                                        </ion-accordion>
                                    }
                                    @if (
                                        areDocumentsAvailable(
                                            machineinfos.retrofitManuals
                                        )
                                    ) {
                                        <ion-accordion>
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "retrofitinstructions"
                                                        | translate
                                                }}</ion-label>
                                            </ion-item>
                                            <app-zmedias
                                                slot="content"
                                                [mode]="'retrofitmanual'"
                                            ></app-zmedias>
                                        </ion-accordion>
                                    }
                                    @if (
                                        areDocumentsAvailable(
                                            machineinfos.assemblingInstructions
                                        )
                                    ) {
                                        <ion-accordion>
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "AssemblingInstructions"
                                                        | translate
                                                }}</ion-label>
                                            </ion-item>
                                            <app-zmedias
                                                slot="content"
                                                [mode]="'assemblingInstructions'"
                                            ></app-zmedias>
                                        </ion-accordion>
                                    }
                                    @if (
                                        areDocumentsAvailable(
                                            machineinfos.repairingInstructions
                                        )
                                    ) {
                                        <ion-accordion>
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "RepairingInstructions"
                                                        | translate
                                                }}</ion-label>
                                            </ion-item>
                                            <app-zmedias
                                                slot="content"
                                                [mode]="'repairingInstructions'"
                                            ></app-zmedias>
                                        </ion-accordion>
                                    }
                                    @if (
                                        areDocumentsAvailable(
                                            machineinfos.sparepartsLists
                                        )
                                    ) {
                                        <ion-accordion value="sparepartlists">
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "sparepartslists"
                                                        | translate
                                                }}</ion-label>
                                            </ion-item>
                                            @if (
                                                isAuthed() ||
                                                viewMode() === "poetdoc"
                                            ) {
                                                <app-zmedias
                                                    slot="content"
                                                    [mode]="'sparepartlists'"
                                                ></app-zmedias>
                                            } @else {
                                                <app-auth-prompt
                                                    slot="content"
                                                    [showTitle]="true"
                                                ></app-auth-prompt>
                                            }
                                        </ion-accordion>
                                    }
                                    @if (
                                        areDocumentsAvailable(
                                            machineinfos.lubricationPlans
                                        )
                                    ) {
                                        <ion-accordion>
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "lubricationplans"
                                                        | translate
                                                }}</ion-label>
                                            </ion-item>
                                            @if (
                                                isAuthed() ||
                                                viewMode() === "poetdoc"
                                            ) {
                                                <app-zmedias
                                                    slot="content"
                                                    [mode]="'lubricationplans'"
                                                ></app-zmedias>
                                            } @else {
                                                <app-auth-prompt
                                                    slot="content"
                                                    [showTitle]="true"
                                                ></app-auth-prompt>
                                            }
                                        </ion-accordion>
                                    }
                                    @if (
                                        areDocumentsAvailable(
                                            machineinfos.mechatronicPlans
                                        ) && viewMode() === "poetdoc"
                                    ) {
                                        <ion-accordion>
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "mechatronicplans"
                                                        | translate
                                                }}</ion-label>
                                            </ion-item>
                                            <app-zmedias
                                                slot="content"
                                                [mode]="'mechatronicplans'"
                                            ></app-zmedias>
                                        </ion-accordion>
                                    }
                                    @if (
                                        declarationOfConformityHeadResource.hasValue()
                                    ) {
                                        <ion-item
                                            color="light"
                                            [button]="true"
                                            detail="false"
                                            lines="full"
                                            (click)="
                                                openDeclarationOfConformity()
                                            "
                                            (keydown.enter)="
                                                openDeclarationOfConformity()
                                            "
                                        >
                                            <ion-label>{{
                                                "declarationOfConformity"
                                                    | translate
                                            }}</ion-label>
                                        </ion-item>
                                    }
                                </ion-accordion-group>
                            </ion-accordion>
                        }
                        @if (
                            machineinfos.images?.length > 0 ||
                            machineinfos.videos?.length > 0 ||
                            areDocumentsAvailable(machineinfos.brochures)
                        ) {
                            <ion-accordion>
                                <ion-item slot="header" color="medium">
                                    <ion-label>{{
                                        "media" | translate
                                    }}</ion-label>
                                </ion-item>
                                <ion-accordion-group
                                    slot="content"
                                    (ionChange)="
                                        scrollIntoView($event.detail.value)
                                    "
                                >
                                    @if (machineinfos.images?.length > 0) {
                                        <ion-accordion>
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "images" | translate
                                                }}</ion-label>
                                            </ion-item>
                                            <app-medien
                                                slot="content"
                                                [images]="machineinfos.images"
                                                [mode]="'images'"
                                            ></app-medien>
                                        </ion-accordion>
                                    }
                                    @if (machineinfos.videos?.length > 0) {
                                        <ion-accordion>
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "videos" | translate
                                                }}</ion-label>
                                            </ion-item>
                                            <app-medien
                                                slot="content"
                                                [videos]="machineinfos.videos"
                                                [mode]="'videos'"
                                            ></app-medien>
                                        </ion-accordion>
                                    }
                                    @if (
                                        areDocumentsAvailable(
                                            machineinfos.brochures
                                        )
                                    ) {
                                        <ion-accordion>
                                            <ion-item
                                                slot="header"
                                                color="light"
                                            >
                                                <ion-label>{{
                                                    "brochures" | translate
                                                }}</ion-label>
                                            </ion-item>
                                            <app-zmedias
                                                slot="content"
                                                [mode]="'brochures'"
                                            ></app-zmedias>
                                        </ion-accordion>
                                    }
                                </ion-accordion-group>
                            </ion-accordion>
                        }
                    </ion-accordion-group>
                </div>
            </div>
        }
    </div>
}
